[...document.querySelectorAll(".js-tabs")].map(tabsComponent => {
    
    const contentElements = [...tabsComponent.querySelectorAll(".js-tab-content")];
    const buttonElements = [...tabsComponent.querySelectorAll("button")];
    if(buttonElements.length == 1) {
        buttonElements[0].parentElement.classList.add("hidden");
    }

    contentElements[0].classList.add("active");
    buttonElements[0].classList.add("active");

    buttonElements.map(button => {
        button.addEventListener("click", (event) => {
            contentElements.map((contentElement) => {
                contentElement.classList.remove('active');
            });
            buttonElements.map((buttonElement) => {
                buttonElement.classList.remove('active');
            });

            button.classList.add("active");
            const index = Array.prototype.indexOf.call(button.parentNode.children, button);
            contentElements[index].classList.add("active");
        });
    });
})